import Raven from 'raven-js';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchInteractiveCardInstance } from '../../clients/fetchInteractiveCardInstance';
import { getSessionId } from '../../selectors/widgetDataSelectors/getSessionId';
import { getInteractiveCardByInstanceId } from '../selectors/getInteractiveCardByInstanceId';
import { deserializeContextFromChirp } from '../operators/deserializeContextFromChirp';
function parseTemplate(template) {
  try {
    return JSON.parse(template);
  } catch (_unused) {
    return null;
  }
}
export const resolveInteractiveCardForMessage = createAsyncThunk('interactiveCards/resolve', async ({
  cardInstanceId,
  threadId
}, {
  getState
}) => {
  const sessionId = getSessionId(getState());
  try {
    var _cardInstance$version;
    const cardInstance = await fetchInteractiveCardInstance({
      cardInstanceId,
      sessionId
    });
    return {
      cardInstanceId,
      threadId,
      cardId: cardInstance.cardId,
      cardInstanceVersion: (_cardInstance$version = cardInstance.version) !== null && _cardInstance$version !== void 0 ? _cardInstance$version : 1,
      stateName: cardInstance.stateName,
      body: cardInstance.template ? parseTemplate(cardInstance.template) : null,
      context: deserializeContextFromChirp(cardInstance.context),
      dynamicText: cardInstance.dynamicTexts,
      locale: cardInstance.locale
    };
  } catch (error) {
    Raven.captureException(error);
    throw error;
  }
}, {
  condition: ({
    cardInstanceId
  }, {
    getState
  }) => {
    const state = getState();
    if (!getSessionId(state)) return false;
    return !getInteractiveCardByInstanceId(state, cardInstanceId);
  }
});